import { buildSliceFilePath } from "./buildSliceFilePath.js";
import { writeProjectFile } from "./writeProjectFile.js";
const writeSliceFile = async (args) => {
  const filePath = await buildSliceFilePath(args);
  const relativeFilePath = await buildSliceFilePath({
    ...args,
    absolute: false
  });
  await writeProjectFile({
    ...args,
    filename: relativeFilePath
  });
  return filePath;
};
export {
  writeSliceFile
};
//# sourceMappingURL=writeSliceFile.js.map
